@if (updatedTreeData?.children?.length > 0) {
  <div #mainPlot id="main-plot"></div>
} @else {
  <div class="no-data-center">
    {{ "common.no_data_small" | translate }}
  </div>
}
